import isEmpty from 'lodash/isEmpty';
import {
    copyProp,
    removeFalsy,
    removeBooleanFalsy,
} from '../../../../commons/utils/fields';

function shouldUseStandardWidgetId(appStore) {
    // Centralize all logic for the 'standardWidgetId' requirement here
    return appStore?.widget?.settingsOrigin === 'event-display';
}

function applyWidgetIdPropName (appStore, body) {
    if (shouldUseStandardWidgetId(appStore)) {
        body.standardWidgetId = body.subscriptionWidgetId;
        delete body.subscriptionWidgetId;
    }
}

function cleanPayload (p) {
    const {
        body,
        appStore,
        env,
        schedulesStore,
    } = p;
    applyWidgetIdPropName(appStore, body);
    if (isEmpty(body.calendarIds) || appStore.autoSubscribe) {
        body.calendarIds = schedulesStore.allScheduleIds;
    }
    copyProp(appStore, body, 'skip_schedule_selection');
    if (body.skip_schedule_selection) delete body.calendarIds;
    
    copyProp(appStore, body, 'oauthSessionId');
    copyProp(env.page?.params, body, 'subscriber_reference', 'reference');
   
    if ('email' in env.page?.params) {
        // only attach secondary email when there's an email in the params
        // always use the email in the params unedited.
        body.secondary_email = env.page.params.email;
    }

    copyProp(appStore.widget, body, 'requiredAge', null, 0);
    copyProp(appStore.widget, body, 'parentalConsentValue', 'parentConsentAge', 0);
    // remove falsy
    removeFalsy(body, 'custom_fields');
    removeBooleanFalsy(body, 'skip_schedule_selection');

    removeBooleanFalsy(body, 'optin');
    if(!body.optin) delete body.optin_id;
    
    removeBooleanFalsy(body, 'secondary_optin');
    if (!body.secondary_optin) delete body.secondary_optin_id; // should we change this to optin2_id

    removeBooleanFalsy(body, 'optin3');
    if (!body.optin3) delete body.optin3_id;

    removeBooleanFalsy(body, 'optin4');
    if (!body.optin4) delete body.optin4_id;

    // delete extra field that captures from the direct params destructure
    delete body.location.securityTokenEnabled;
    delete body.location.status;
    delete body.location.statusLong;
    delete body.codeIndex;

    delete body.countryCode;
    delete body.phoneCountry;

    // enforce IP Location country code
    if (!body.country) body.country = body.location.country_code;
    // change value 
    if (body.application === 'android') {
        body.application = 'google';
    }

}
export default cleanPayload;
